//React imports
import React        from 'react';
import ReactDOM     from 'react-dom';

//Redux imports
import { Provider }   from 'react-redux';
import store          from "./redux/index";

import * as routes from 'constants/routes';

//Router
import {BrowserRouter, Route} from 'react-router-dom';

//Device state is responsible for determining responsive view states(mobile,table,desktop)
import deviceState from './app/device_state/index';

//Root component
import App from './App';

//Device state handles responsive updates
new deviceState(store.dispatch);

window.store = store;

ReactDOM.render(
    <BrowserRouter basename={'/'}>
        <Route path="/" render={({location}) => {
            //handle analytics reporting
            let report_location  = location.pathname;
            if(location.pathname === '/') { report_location = routes.home }

            if (typeof window.gtag === 'function') {
                window.gtag('config', 'GTM-TQFGHK2', {
                    'page_path': report_location
                });
            }

            if(typeof window.fbq === 'function') {
                window.fbq('track', 'PageView');
            };

            return null;
        }} />
        <Provider store = {store}>
            <App />
        </Provider>
    </BrowserRouter>,
    document.getElementById('root')
);